import styled, { css } from 'styled-components/macro';
import tw from 'tailwind.macro';
import { colors } from '../../styles/constants';

const Grid = styled.div`
  ${tw`flex flex-wrap justify-start`};
`;

const arrowLinkStyle = css`
  ${tw`flex py-def justify-between cursor-pointer
    w-12 md:w-6 lg:w-4
    sm:justify-start`};
  border-bottom: 1px solid ${colors.grey200};
  text-decoration: none;
  -webkit-font-smoothing: antialiased;
  -webkit-touch-callout: none;
  color: ${colors.primary400};
`;

const ArrowLink = styled.a`
  ${arrowLinkStyle}
`;

const AlignTravel = styled.div`
  ${tw`flex w-full
    mr-abs1`};
  max-width: 250px;
`;

export { AlignTravel, ArrowLink, arrowLinkStyle, Grid };
